import {Platform} from 'react-native';

export const getPreparedImageToUploading = (image?: string) => {
  let imageName = '';
  let imageExpansion = '';

  if (image) {
    if (image.includes('http')) {
      return {uri: '', name: '', type: ''};
    }

    const imageUrlSplit = image?.split('/');
    imageName = imageUrlSplit[imageUrlSplit?.length - 1];
    imageExpansion = imageName.split('.')[1];

    return {
      uri: Platform.OS === 'ios' ? image.replace('file://', '') : image,
      name: imageName,
      type: 'image/' + imageExpansion,
    };
  }
  return {
    uri: '',
    name: '',
    type: '',
  };
};
